import { __assign, __awaiter, __generator } from "tslib";
import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { decodeBase64URL, encodeBase64URL } from '../base64url';
import { stringify } from '../../../utils';
import { logTaggedMessage } from '../../reporter';
import { collectBrowserInfo } from '../collectBrowserInfo';
import { threeDsErrors } from '../3ds-utils';
var log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'adyen-fingerprint',
});
var parseFingerprintPostData = function (postData) {
    if (typeof postData !== 'object' ||
        !postData.threeDSMethodData) {
        throw new ThreeDsFormattingException("invalid FingerprintRawPostData: ".concat(stringify(postData)));
    }
    var decoded;
    try {
        decoded = decodeBase64URL(postData.threeDSMethodData);
    }
    catch (e) {
        throw new ThreeDsFormattingException("failed to decode invalid FingerprintRawPostData.threeDSMethodData: ".concat(stringify(postData)));
    }
    var parsedObj;
    try {
        parsedObj = JSON.parse(decoded);
    }
    catch (e) {
        throw new ThreeDsFormattingException("failed to JSON.parse invalid decoded FingerprintRawPostData.\n        postData: ".concat(stringify(postData), "\n        threeDSMethodData: ").concat(decoded));
    }
    if (typeof parsedObj.threeDSServerTransID !== 'string') {
        throw new ThreeDsFormattingException("invalid FingerprintResponseData: ".concat(decoded));
    }
    return parsedObj;
};
var encodeRequestData = function (data) {
    var encodedData = encodeBase64URL(JSON.stringify(data, null, 2));
    var postData = {
        threeDSMethodData: encodedData,
    };
    return postData;
};
export var performFingerprint = function (_a) {
    var methodUrl = _a.methodUrl, actionData = _a.data, provider = _a.provider, notificationUrl = _a.notificationUrl;
    return __awaiter(void 0, void 0, void 0, function () {
        var challengeDisplaySize, browserInfo, _b, threeDSServerTransID, threeDS2Token, dataToServer, success, fail, reqData, rawPostData, logData, ret, fingerprintResultPromise, fingerprintResult, err, ret, e_1, ret;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    challengeDisplaySize = getThreeDsChallengeDisplaySize();
                    browserInfo = collectBrowserInfo();
                    _b = actionData, threeDSServerTransID = _b.threeDSServerTransID, threeDS2Token = _b.threeDS2Token;
                    dataToServer = {
                        token: threeDS2Token,
                    };
                    success = function () { return ({
                        fingerprintData: {
                            challengeDisplaySize: challengeDisplaySize,
                            received: {},
                            provider: provider,
                            data: dataToServer,
                            browserInfo: browserInfo,
                        },
                    }); };
                    fail = function (error) {
                        return {
                            fingerprintData: {
                                challengeDisplaySize: challengeDisplaySize,
                                provider: provider,
                                notReceived: { error: error },
                                data: dataToServer,
                                browserInfo: browserInfo,
                            },
                        };
                    };
                    reqData = {
                        threeDSServerTransID: threeDSServerTransID,
                        threeDSMethodNotificationURL: notificationUrl,
                    };
                    rawPostData = encodeRequestData(reqData);
                    logData = {
                        methodUrl: methodUrl,
                        provider: provider,
                        actionData: actionData,
                        notificationUrl: notificationUrl,
                        dataToServer: dataToServer,
                        reqData: reqData,
                        rawPostData: rawPostData,
                    };
                    log('3ds: before render 3ds Adyen fingerprint iframe', logData);
                    if (!methodUrl) {
                        ret = fail(threeDsErrors.missingUrl('ADYEN', 'fingerprint'));
                        log("3ds: Adyen Device Fingerprint failed", __assign(__assign({}, logData), { ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    fingerprintResultPromise = renderIframeAndWaitForPostback('hidden', methodUrl, 'POST', rawPostData).then(parseFingerprintPostData);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fingerprintResultPromise];
                case 2:
                    fingerprintResult = _c.sent();
                    if (fingerprintResult.threeDSServerTransID !== threeDSServerTransID) {
                        err = "adyen fingerprint transactionId dont match!\n        sent: ".concat(threeDSServerTransID, ",\n        recived: ").concat(fingerprintResult.threeDSServerTransID);
                        ret = fail(err);
                        log("3ds: Adyen Device Fingerprint failed", __assign(__assign({}, logData), { err: err, ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    log('3ds: received Adyen fingerprint success', __assign(__assign({}, logData), { fingerprintResult: fingerprintResult }));
                    return [2 /*return*/, success()];
                case 3:
                    e_1 = _c.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'ADYEN',
                        step: 'fingerprint',
                        e: e_1,
                    }));
                    log("3ds: Adyen Device Fingerprint failed", __assign(__assign({}, logData), { ret: ret, e: e_1 }));
                    return [2 /*return*/, ret];
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=adyen-fingerprint.js.map